var map = {
	"./en-au": 639,
	"./en-au.js": 639,
	"./en-ca": 640,
	"./en-ca.js": 640,
	"./en-gb": 641,
	"./en-gb.js": 641,
	"./en-ie": 642,
	"./en-ie.js": 642,
	"./en-il": 643,
	"./en-il.js": 643,
	"./en-in": 644,
	"./en-in.js": 644,
	"./en-nz": 645,
	"./en-nz.js": 645,
	"./en-sg": 646,
	"./en-sg.js": 646
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3816;



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 3816
// module chunks = 0